import { render, staticRenderFns } from "./WorkerDocs.vue?vue&type=template&id=fa060b30&scoped=true"
import script from "./WorkerDocs.vue?vue&type=script&lang=ts"
export * from "./WorkerDocs.vue?vue&type=script&lang=ts"
import style0 from "./WorkerDocs.vue?vue&type=style&index=0&id=fa060b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa060b30",
  null
  
)

export default component.exports